import type zh from '../zh/workspace';

/** Workspace, English. Typed against the zh file so a missing key fails tsc. */
const workspace: typeof zh = {
  nav: {
    label: 'Workspace navigation',
    title: 'Workspace',
    resize: 'Drag to resize; double-click to reset',
    collapse: 'Collapse',
    collapseLabel: 'Collapse workspace panel',
    search: 'Search',
    searchLabel: 'Search workspace',
    recent: 'Recent',
    loading: 'Loading workspace...',
    loadFailed: 'Failed to load workspace',
    empty: 'No items in workspace',
    emptyFolder: 'No items',
    noMatches: 'No matching items',
  },
  home: {
    busy1: '☕ Rocky is thinking. Grab a cup of tea~',
    busy2: '🧠 Rocky is still busy. Let it finish first~',
    busy3: '⏳ Wait for Rocky to finish replying~',
    busy4: '🍵 Rocky is focused. Try again in a moment~',
    readOnly: '👀 Admin view mode: actions are disabled',
    queueFull: 'The queue holds at most 3 questions',
    promptsLink: 'Rocky Prompts by Scenario · Copy and Use',
    guideLink: 'Guide to Choosing a CMHK AI Agent',
    badgeNew: 'NEW',
    badgeHot: 'HOT',
  },
  viewer: {
    loading: 'Loading report...',
    loadImageFailed: 'Failed to load image',
    loadReportFailed: 'Failed to load report',
    cannotPreview: 'This file type cannot be previewed',
    download: 'Download',
    downloading: 'Downloading...',
    downloadTitle: 'Download report',
    downloadFailed: 'Download failed. Please try again.',
    csvTruncated: 'Showing the first {{shown}} of {{total}} rows. Download the file to see the rest.',
    csvTotal: '{{total}} rows',
  },
  openFile: {
    noAccess:
      "Can't open this file in the Rocky workspace: your account is not in the {{groups}} LDAP group.\n\nRequest access here:\n{{url}}",
  },
};

export default workspace;
